/** @jsxImportSource @emotion/react */
import React, { memo } from 'react';
import locationLegendBlockStyles from './location-legend-block.styles';
import { Legend } from '../legend/legend.component';
import LocationButton from '../location-button/location-button.component';
import { useMapTargetToUser } from '../leaflet-map/useMapTargetToUser';
import BetaTile from '../../app/main/components/beta-tile/beta-tile.component';

const LocationLegendBlock = () => {
    const { targetToUser } = useMapTargetToUser();

    const handleClickLocationButton = () => {
        targetToUser();
    };

    return (
        <div css={locationLegendBlockStyles.locationLegendBlock}>
            <BetaTile />
            <div css={locationLegendBlockStyles.buttonsBlock}>
                <Legend />
                <LocationButton onClick={handleClickLocationButton} />
            </div>
        </div>
    );
};

export default memo(LocationLegendBlock);
